
import { CheckIcon, XIcon } from 'lucide-react';
import type { Word } from '@/lib/game-utils';

interface WordRowProps {
  userWord: Word | string;
  targetWord: Word | string;
  isMatch: boolean;
  wordLink?: string;
  isHighlighted: boolean;
  isClicked: boolean;
  onLinkClick: () => void;
}

export function WordRow({
  userWord,
  targetWord,
  isMatch,
  wordLink,
  isHighlighted,
  isClicked,
  onLinkClick
}: WordRowProps) {
  const hasLink = wordLink && wordLink.trim() !== '';
  
  return (
    <div className="flex items-center justify-center gap-2 relative">
      <div className="w-[40%] bg-gray-100 p-3 rounded text-center">
        {String(userWord)}
      </div>
      <div className="flex-shrink-0 absolute left-1/2 transform -translate-x-1/2 z-10">
        {isMatch ? (
          <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center shadow-sm">
            <CheckIcon className="text-white w-4 h-4" />
          </div>
        ) : (
          <div className="w-6 h-6 bg-[#D4D4DC] rounded-full flex items-center justify-center shadow-sm">
            <XIcon className="text-white w-4 h-4" />
          </div>
        )}
      </div>
      <div className="w-[40%] bg-gray-100 p-3 rounded text-center relative">
        {hasLink ? (
          <a 
            href={wordLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className={isHighlighted ? 'link-highlight-animation' : ''}
            onClick={onLinkClick}
            style={{
              color: isClicked ? '#000000' : isHighlighted ? '#0000EE' : 'inherit',
              textDecoration: 'underline'
            }}
          >
            {String(targetWord)}
          </a>
        ) : (
          String(targetWord)
        )}
      </div>
    </div>
  );
}
